import type {
	StageTemplate as ApiStageTemplate,
	StageTemplateItem as ApiStageTemplateItem,
} from "@/adapters/api";
import type { StageTemplate, TemplateItem } from "../types.ts";

export function toStageTemplate(t: ApiStageTemplate): StageTemplate {
	return {
		id: t.id,
		name: t.name,
		description: t.description,
		createdAt: t.created_at,
		updatedAt: t.updated_at,
	};
}

export function toTemplateItem(i: ApiStageTemplateItem): TemplateItem {
	return {
		id: i.id,
		parentId: i.parent_item_id,
		name: i.name,
		description: i.description,
		kind: i.kind,
		position: i.position,
		depth: i.depth ?? 0,
	};
}
